export default "__VITE_ASSET__7d5d42c7__"